import { RibbonIconColor } from 'owa-command-ribbon';
import type { RibbonId } from 'owa-ribbon-ids';
import {
    MailRibbonGroupId,
    MailRibbonControlId,
    FormatControlId,
    ActionControlId,
} from 'owa-ribbon-ids';

let MailIconColorMap: Map<RibbonId, RibbonIconColor>;

export function getMailIconColorMap(): Map<RibbonId, RibbonIconColor> {
    if (!MailIconColorMap) {
        initializeMailIconColorMap();
    }

    return MailIconColorMap;
}

/**
 * Initializes the color map for Mail Ribbon.
 */
function initializeMailIconColorMap() {
    MailIconColorMap = new Map();

    MailIconColorMap.set(MailRibbonControlId.AddressBook, RibbonIconColor.gray)
        .set(MailRibbonControlId.Archive, RibbonIconColor.green)
        .set(MailRibbonControlId.AssignPolicy, RibbonIconColor.blue)
        .set(MailRibbonControlId.AttachFile, RibbonIconColor.gray)
        .set(MailRibbonControlId.AttachFileFromComputer, RibbonIconColor.gray)
        .set(MailRibbonControlId.AttachFileFromOnlineLocation, RibbonIconColor.gray)
        .set(MailRibbonControlId.AttachFileFromUpload, RibbonIconColor.blue)
        .set(MailRibbonControlId.AttachSig, RibbonIconColor.blue)
        .set(MailRibbonControlId.Block, RibbonIconColor.red)
        .set(MailRibbonControlId.BrowseGroups, RibbonIconColor.gray)
        .set(MailRibbonControlId.Categorize, RibbonIconColor.gray)
        .set(MailRibbonControlId.CategorizeNewCategory, RibbonIconColor.red)
        .set(MailRibbonControlId.CheckForAccessibilityIssues, RibbonIconColor.green)
        .set(MailRibbonControlId.CheckNames, RibbonIconColor.green)
        .set(MailRibbonControlId.Copy, RibbonIconColor.gray)
        .set(MailRibbonControlId.CreateRule, RibbonIconColor.gray)
        .set(MailRibbonControlId.Cut, RibbonIconColor.blue)
        .set(MailRibbonControlId.DeleteItem, RibbonIconColor.gray)
        .set(MailRibbonControlId.Dictate, RibbonIconColor.blue)
        .set(MailRibbonControlId.DiscardDraft, RibbonIconColor.gray)
        .set(MailRibbonControlId.DynamicMenuButton, RibbonIconColor.green)
        .set(MailRibbonControlId.Encrypt, RibbonIconColor.yellow)
        .set(MailRibbonControlId.Encrypt_SingleButton, RibbonIconColor.yellow)
        .set(MailRibbonControlId.FlagUnflag, RibbonIconColor.red)
        .set(MailRibbonControlId.FormatPainter, RibbonIconColor.yellow)
        .set(MailRibbonControlId.GetAddIns, RibbonIconColor.orange)
        .set(MailRibbonGroupId.Group_Find, RibbonIconColor.gray)
        .set(MailRibbonGroupId.Group_Groups, RibbonIconColor.gray)
        .set(MailRibbonGroupId.Group_Move, RibbonIconColor.blue)
        .set(MailRibbonGroupId.Group_QuickSteps, RibbonIconColor.green)
        .set(MailRibbonGroupId.Group_Tags, RibbonIconColor.red)
        .set(MailRibbonControlId.HighImportance, RibbonIconColor.red)
        .set(MailRibbonControlId.IgnoreStopIgnore, RibbonIconColor.red)
        .set(MailRibbonControlId.ImmersiveReader, RibbonIconColor.blue)
        .set(MailRibbonControlId.Insights, RibbonIconColor.gray)
        .set(MailRibbonControlId.JunkFlyout, RibbonIconColor.red)
        .set(MailRibbonControlId.JunkNotJunk, RibbonIconColor.red)
        .set(MailRibbonControlId.LowImportance, RibbonIconColor.blue)
        .set(MailRibbonControlId.ManageRules, RibbonIconColor.blue)
        .set(MailRibbonControlId.MarkComplete, RibbonIconColor.green)
        .set(MailRibbonControlId.Move, RibbonIconColor.blue)
        .set(MailRibbonControlId.NewEvent, RibbonIconColor.gray)
        .set(MailRibbonControlId.NewGroup, RibbonIconColor.gray)
        .set(MailRibbonControlId.NewItems, RibbonIconColor.gray)
        .set(MailRibbonControlId.NewMessage, RibbonIconColor.gray)
        .set(MailRibbonControlId.NewNote, RibbonIconColor.gray)
        .set(MailRibbonControlId.OtherFolder, RibbonIconColor.blue)
        .set(MailRibbonControlId.Paste, RibbonIconColor.yellow)
        .set(MailRibbonControlId.Phishing, RibbonIconColor.yellow)
        .set(MailRibbonControlId.PinUnpin, RibbonIconColor.blue)
        .set(MailRibbonControlId.Print, RibbonIconColor.gray)
        .set(MailRibbonControlId.ReadAloud, RibbonIconColor.blue)
        .set(MailRibbonControlId.ReadUnread, RibbonIconColor.gray)
        .set(MailRibbonControlId.ReplyWithMeeting, RibbonIconColor.purple)
        .set(MailRibbonControlId.ReportMessage, RibbonIconColor.blue)
        .set(MailRibbonControlId.RespondForward, RibbonIconColor.blue)
        .set(MailRibbonControlId.RespondReply, RibbonIconColor.purple)
        .set(MailRibbonControlId.RespondReplyAll, RibbonIconColor.purple)
        .set(MailRibbonControlId.Save, RibbonIconColor.purple)
        .set(MailRibbonControlId.SendDraft, RibbonIconColor.gray)
        .set(MailRibbonControlId.Sensitivity, RibbonIconColor.blue)
        .set(MailRibbonControlId.SetQuickActions, RibbonIconColor.gray)
        .set(MailRibbonControlId.ShowLinkDialog, RibbonIconColor.gray)
        .set(MailRibbonControlId.ShowMessageOptions, RibbonIconColor.blue)
        .set(MailRibbonControlId.SetImportance, RibbonIconColor.red)
        .set(MailRibbonControlId.Snooze, RibbonIconColor.gray)
        .set(MailRibbonControlId.Sweep, RibbonIconColor.gray)
        .set(MailRibbonControlId.Undo, RibbonIconColor.gray)
        .set(MailRibbonControlId.Unsnooze, RibbonIconColor.blue)
        .set(MailRibbonControlId.Emojis, RibbonIconColor.yellow)
        .set(MailRibbonControlId.Pictures, RibbonIconColor.blue)
        .set(FormatControlId.UndoRedo, RibbonIconColor.gray)
        .set(FormatControlId.FormatPainter, RibbonIconColor.yellow)
        .set(FormatControlId.Bold, RibbonIconColor.gray)
        .set(FormatControlId.Italic, RibbonIconColor.gray)
        .set(FormatControlId.Underline, RibbonIconColor.gray)
        .set(FormatControlId.RemoveFormat, RibbonIconColor.gray)
        .set(FormatControlId.ChangeCase, RibbonIconColor.gray)
        .set(FormatControlId.StrikeThrough, RibbonIconColor.gray)
        .set(FormatControlId.Superscript, RibbonIconColor.gray)
        .set(FormatControlId.Subscript, RibbonIconColor.gray)
        .set(FormatControlId.Numbering, RibbonIconColor.gray)
        .set(FormatControlId.Bullets, RibbonIconColor.gray)
        .set(FormatControlId.Indent, RibbonIconColor.gray)
        .set(FormatControlId.Outdent, RibbonIconColor.gray)
        .set(FormatControlId.AlignLeft, RibbonIconColor.gray)
        .set(FormatControlId.AlignCenter, RibbonIconColor.gray)
        .set(FormatControlId.AlignRight, RibbonIconColor.gray)
        .set(FormatControlId.LeftToRight, RibbonIconColor.gray)
        .set(FormatControlId.RightToLeft, RibbonIconColor.gray)
        .set(FormatControlId.Quote, RibbonIconColor.gray)
        .set(FormatControlId.PasteCutCopy, RibbonIconColor.yellow)
        //action controls
        .set(ActionControlId.Emoji, RibbonIconColor.yellow)
        .set(ActionControlId.Fluid, RibbonIconColor.gray)
        .set(ActionControlId.AddInlineImage, RibbonIconColor.orange)
        .set(ActionControlId.ProofingOptions, RibbonIconColor.gray)
        .set(ActionControlId.SwitchBodyType, RibbonIconColor.gray)
        .set(ActionControlId.DarkTheme, RibbonIconColor.gray)
        .set(ActionControlId.CheckForAccessibilityIssues, RibbonIconColor.green)
        .set(ActionControlId.GetAddIns, RibbonIconColor.orange)
        .set(ActionControlId.AttachFile, RibbonIconColor.gray)
        .set(ActionControlId.AttachSig, RibbonIconColor.blue)
        .set(ActionControlId.Save, RibbonIconColor.purple)
        .set(ActionControlId.Sensitivity, RibbonIconColor.blue)
        .set(ActionControlId.HighImportance, RibbonIconColor.red)
        .set(ActionControlId.LowImportance, RibbonIconColor.blue)
        .set(ActionControlId.NormalImportance, RibbonIconColor.gray)
        .set(ActionControlId.SetImportance, RibbonIconColor.red)
        .set(ActionControlId.ShowFrom, RibbonIconColor.gray)
        .set(ActionControlId.ShowMessageOptions, RibbonIconColor.gray)
        .set(ActionControlId.Sensitivity_LearnMore, RibbonIconColor.gray);
}
